"use strict";

exports.__esModule = true;
exports.downloadSeriesData = exports.DATE_FORMAT = void 0;
var _echartsForReact = require("echarts-for-react");
var _momentTimezone = require("moment-timezone");
var _date = require("./date");
var _Utils = require("../../../Utils");
var TIMESTAMP_HEADER = "Timestamp";
var DEVICE_HEADER = "Device";
var DATA_ITEM_HEADER = "Data item name";
var VALUE_HEADER = "Value";
var DATE_FORMAT = exports.DATE_FORMAT = "YYYY-MM-DD HH:mm:ss";
var formatDataSeries = function formatDataSeries(series, timezone) {
  var headers = [];
  var rows = [];
  headers.push(TIMESTAMP_HEADER, DEVICE_HEADER, DATA_ITEM_HEADER, VALUE_HEADER);
  series.forEach(function (seriesValue, index) {
    if (seriesValue.type === "line") {
      if (index !== 0) {
        rows.push(["", "", "", ""]);
      }
      seriesValue.data.forEach(function (seriesData) {
        rows.push([(0, _date.formatDate)(seriesData[0], timezone, DATE_FORMAT), seriesValue.device, seriesValue.dataItem, seriesData[1]]);
      });
    }
  });
  return {
    headers: headers,
    rows: rows
  };
};
var downloadSeriesData = exports.downloadSeriesData = function downloadSeriesData(series, timezone, name) {
  (0, _Utils.downloadCSVData)(formatDataSeries(series, timezone), name);
};